<template>
  <ClinicalForm form-key-prefix="screening" :title="'Screening'" />
</template>

<script>
// The Screening questionnaire. The actual field schema is reconstructed from the
// compiled bundle's vue-formulate definitions (see src/forms/schemas/) and
// rendered by the shared <ClinicalForm> wrapper, which loads/saves forms.data.
//
// TODO(schema): populate src/forms/schemas/screening.js from the extracted
// schema and verify field-by-field against the live app.
import ClinicalForm from 'components/ClinicalForm.vue'
export default { name: 'ScreeningView', components: { ClinicalForm } }
</script>
